import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const ProjectHeaderDL = styled.dl`
  display: flex;
  gap: ${spacing.quarter};
  > dd {
    margin-right: ${spacing.base};
  }
`;
